// Exact interface copy only. Store names and free text remain unchanged.
export default {
  "صنف مبلغ مفتوح سابق — موقوف عن البيع.": "Former open-amount product — sales disabled.",
  "رقم الصنف في الميزان (PLU)": "Scale product number (PLU)",
  "اختياري: 1 إلى 99999": "Optional: 1 to 99999",
  "للبيع بملصق الميزان؛ الوحدة كجم، والسعر والتكلفة لكل كيلوجرام.": "Sold using a scale label; unit is kg, and price and cost are per kilogram.",
  "رقم صنف الميزان يجب أن يكون من 1 إلى 99999": "Scale PLU must be from 1 to 99999",
  "رقم صنف الميزان مربوط بمنتج آخر": "This scale PLU is linked to another product",
  "وحدة صنف الميزان يجب أن تكون كجم؛ السعر والتكلفة لكل كيلوجرام": "A scale product must use kg; price and cost are per kilogram",
  "صنف الميزان لا يكون مفتوح المبلغ": "A scale product cannot use an open amount",
  "سعر الكيلوجرام لصنف الميزان يجب أن يكون موجباً وبدقة هللتين": "The scale product kilogram price must be positive with two decimal places",
  "مورد جديد — يُنشأ عند الاعتماد": "New supplier — created on approval",
  "مورد جديد — يُنشأ عند الحفظ": "New supplier — created when saved",
  "أنشئه صنفاً جديداً": "Create as a new product",
  "اختر المورد أو اكتب اسم مورد جديد": "Choose a supplier or enter a new supplier name",
  "— ما نزل هامشه تحت": "— for margins below",
  "ما نزل هامشه تحت": "For margins below",
  "٪ يُقترح رفعه إلى": "%, suggest a price increase to reach",
  "٪ يُرفع": "%, increase the price to reach",
  "٪ يُرفع إلى": "%, increase the price to reach",
  "٪ مقرَّباً لأعلى لأقرب ربع ريال. لا يُخفَّض سعر أبداً، ولا يُمسّ صنف مفتوح المبلغ.": "%, rounded up to the nearest SAR 0.25. Prices are never reduced and open-amount products are excluded.",
  "٪ مقرَّباً لأعلى لأقرب ربع ريال.": "%, rounded up to the nearest SAR 0.25.",
  "مقرَّباً لأعلى لأقرب ربع ريال.": "rounded up to the nearest SAR 0.25.",
  "— التكاليف المسجَّلة سابقاً ليست بجودة تكلفة سطرٍ راجعته للتوّ، فالاختيار يدوي سطراً سطراً. ولا يُخفَّض سعر أبداً.": "Previously recorded costs need individual review. Select each product manually. Selling prices will never be reduced.",
  "لديك تعديلات غير محفوظة على هذا الصنف. الخروج الآن يفقدها.": "This product has unsaved changes. Leaving will discard them.",
  "سعر البيع (0 = يُحدَّد لاحقاً)": "Selling price (0 = set later)",
  "0 = الفاتورة كلها آجلة": "0 = invoice fully on account",
  "0 = الطلب كله آجل": "0 = order fully on account",
  "لديك تعديلات غير محفوظة على بيانات العميل. الخروج الآن يفقدها.": "This customer has unsaved changes. Leaving will discard them.",
  "لديك تعديلات غير محفوظة على المنتج. الخروج الآن يفقدها.": "This product has unsaved changes. Leaving will discard them.",
  "انتظر اكتمال قراءة الفاتورة أو حفظها قبل المغادرة.": "Wait for the invoice to finish reading or saving before leaving.",
  "لديك مدخلات فاتورة غير محفوظة؛ احفظها كمسودة لاستكمالها لاحقاً.": "This invoice has unsaved changes. Save a draft to continue later.",
  "حفظ واستكمال لاحقًا": "Save and continue later",
  "شعار بيت الحناء والعطارة": "Bait Henna & Herbs logo",
  "إيصال سداد دفعة": "Payment receipt",
  "العميل:": "Customer:",
  "طريقة السداد:": "Payment method:",
  "المبلغ المسدَّد": "Amount paid",
  "المتبقي عليه": "Amount still owed",
  "رصيد دائن له": "Customer credit balance",
  "ابحث باسم المستخدم أو نوع العملية...": "Search by user or action...",
  "تحديث": "Refresh",
  "تسجيل سداد من الدَين": "Record debt payment",
  "رقم سند أو ملاحظة": "Receipt number or note",
  "جاري تحميل ملف العميل...": "Loading customer record...",
  "الدفع": "Payment",
  "بيع آجل يزيد الرصيد · السداد والمرتجع ينقصانه": "Sales on account increase the balance; payments and returns reduce it",
  "الحركة": "Activity",
  "الرصيد المستحق حالياً:": "Current amount due:",
  "رصيد دائن للعميل:": "Customer credit balance:",
  "لا يوجد رصيد — أي مبلغ سيُسجَّل كدفعة مقدّمة": "No outstanding balance — payments will be recorded as advance credit",
  "المبلغ المسدَّد (ر.س)": "Payment amount (SAR)",
  "هذا الإيصال ليس فاتورة ضريبية — سداد دَين سابق بلا ضريبة": "Payment receipt for a previous debt; this is not a tax invoice and includes no additional tax",
  "مثال: الصنف تالف · العميل غيّر رأيه · خطأ في الكمية": "Example: damaged product · customer changed their mind · incorrect quantity",
  "لا توجد بنود مسجّلة لهذه الفاتورة": "No items recorded for this invoice",
  "مجموع الأصناف": "Items subtotal",
  "إرجاع أصناف من هذه الفاتورة": "Return products from this invoice",
  "اختر الأصناف والكميات المراد إرجاعها. اتركها كاملة لإرجاع الفاتورة كلها. الإرجاع لا يحذف الفاتورة — يُسجَّل قيداً عكسياً موثّقاً.": "Choose the products and quantities to return, or keep all quantities for a full return. A return creates a documented reversing entry and preserves the original invoice.",
  "المُباع": "Sold",
  "سبق إرجاعه": "Previously returned",
  "أُرجع بالكامل": "Fully returned",
  "كيف سيُردّ المبلغ (حسب توزيع الدفع الأصلي)": "Refund method (based on the original payment split)",
  "يُخصم من دَين العميل": "Deducted from customer debt",
  "يعود إلى رصيده الدائن": "Added back to customer credit",
  "ابحث باسم الموظف أو الجوال أو البريد...": "Search by employee name, mobile, or email...",
  "هذه الصفحة متاحة للإدارة فقط": "This page is available to administrators only",
  "عيّن كلمة مرور مؤقتة ثم بلّغ الموظف بها بطريقة آمنة": "Set a temporary password and share it securely with the employee",
  "تحتاج إلى موافقتك قبل أن يستطيع البائع تسجيل الدخول": "Your approval is required before the salesperson can sign in",
  "قبول": "Approve",
  "سيتم إنهاء جميع جلسات هذا الحساب بعد حفظ كلمة المرور المؤقتة.": "Saving a temporary password ends all active sessions for this account.",
  "كلمة المرور المؤقتة": "Temporary password",
  "حفظ كلمة المرور": "Save password",
  "حبة": "piece",
  "حذف البند": "Remove item",
  "الوحدة": "Unit",
  "تسوية": "Adjust",
  "جاري تحميل المبيعات المرحّلة...": "Loading imported sales...",
  "عمليات البيع": "Sales transactions",
  "عمليات": "transactions",
  "مرتجعات": "returns",
  "صافي الفترة:": "Net for this period:",
  "إجمالي ما سيُرحَّل الآن:": "Total to import:",
  "لا يمسّ هذا فواتير النظام ولا المخزون — يحذف الملخصات التاريخية فقط، وهي قابلة لإعادة الاستيراد من الملفات نفسها.": "Only historical summaries will be deleted. Invoices and inventory are unaffected. The summaries can be imported again from the same files.",
  "ابحث في هذه الشريحة...": "Search this group...",
  "كم وحدة يجب أن تحويها العبوة ليصير سعرك منطقياً": "Estimated number of units per pack consistent with the selling price",
  "القاعدة لم تُجِز أياً من الأسعار المحدَّدة.": "None of the selected prices meet the pricing rule.",
  "جاري حساب الهوامش...": "Calculating margins...",
  "وحدة": "units",
  "سيُرفع سعر": "The price will increase for",
  "صنف. تُؤخذ نسخة احتياطية من القاعدة قبل الكتابة، ويُقيَّد كل تغيير في سجل التدقيق باسم الصنف والسعرين والسبب.": "products. A backup is taken before saving, and each change is logged with the product name, old and new prices, and reason.",
  "السبب": "Reason",
  "عنوان المؤسسة في الفاتورة": "Business address on the invoice",
  "طريقة دفع العميل": "Customer payment method",
  "المبلغ المستلم (ر.س)": "Amount received (SAR)",
  "مصدر احتساب الضريبة": "VAT reporting source",
  "الرقم الضريبي للعميل": "Customer VAT number",
  "تاريخ العرض": "Quotation date",
  "هذا عرض سعر وليس فاتورة ضريبية. الأسعار سارية حتى التاريخ المذكور أعلاه، وتخضع لتوفّر الأصناف وقت الطلب.": "This quotation is not a tax invoice. Prices are valid until the date above, subject to product availability when ordered.",
  "تعديل العرض": "Edit quotation",
  "فاتورة محفوظة لطلب المتجر": "Saved online store invoice",
  "اعتماد العرض وإصدار فاتورته": "Approve quotation and issue invoice",
  "سيُحفظ مستند الفاتورة دون إضافة بيع أو تحصيل أو خصم مخزون في الكاشير. اربط رقم الطلب الأصلي لمنع إصدار فاتورتين لنفس الطلب.": "The invoice document is saved without adding a POS sale, payment, or stock deduction. Link the original order number to prevent duplicate invoices.",
  "تقارير سلة / محاسبة المتجر الخارجية": "Salla reports / external store accounting",
  "كشف الضريبة في هذا النظام": "VAT statement in this system",
  "تحققت من استلام كامل المبلغ بطريقة الدفع المختارة": "I verified receipt of the full amount using the selected payment method",
  "لم تصدر فاتورة ضريبية لهذا الطلب من سلة أو أي نظام آخر": "No tax invoice for this order has been issued by Salla or another system",
  "عدّل العرض واختر عميلاً مسجلاً أولاً.": "Edit the quotation and select a registered customer first.",
  "جاري تحميل بيانات الصنف...": "Loading product details...",
  "الكمية المباعة": "Quantity sold",
  "آخر بيع": "Last sale",
  "الكاشير يكتب المبلغ بالريال بدل الكمية. يُثبَّت السعر على ريال واحد والوحدة «ريال» تلقائياً، فاكتب في خانة التكلفة": "The cashier enters the amount in SAR. The unit price is fixed at SAR 1. Enter the cost per SAR in the cost field",
  "— مثال: 0.48 يعني هامش 52%.": "— for example, 0.48 gives a 52% margin.",
  "رمز SKU": "SKU",
  "تحديد كل الظاهر": "Select all visible",
  "طباعة الباركود": "Print barcodes",
  "فتح المحرّر": "Open editor",
  "طباعة باركود المنتج": "Print product barcode",
  "توليد باركود للأصناف الناقصة": "Generate missing barcodes",
  "لا يوجد صنف بلا باركود": "No products with missing barcodes",
  "كل الأصناف النشطة لها باركود.": "All active products have barcodes.",
  "العودة للأصناف النشطة": "Back to active products",
  "توليد باركود للناقص": "Generate missing barcodes",
  "إلغاء التحديد": "Clear selection",
  "إعادة تفعيل المحدد": "Reactivate selected",
  "إيقاف المحدد": "Deactivate selected",
  "مبلغ مفتوح": "Open amount",
  "كمية مفتوحة": "Unlimited quantity",
  "ستعود هذه الأصناف إلى شاشة الكاشير وقوائم المنتجات": "These products will return to POS and the catalog",
  "فوراً": "immediately",
  "بأسعارها وبياناتها كما تركتها. راجع أسعارها بعد التفعيل إن طال توقفها.": "with their saved prices and details. Review prices if they have been inactive for a long time.",
  "الإيقاف يرفع الصنف من شاشة الكاشير ومن القوائم والتقارير القادمة،": "Deactivation removes products from POS, the catalog, and future reports,",
  "ولا يمسّ الفواتير القديمة": "while preserving previous invoices",
  "— مبيعاته السابقة وأرباحها تبقى في التقارير كما هي. ويمكنك إرجاعه متى شئت من زر «الأصناف الموقوفة» أعلى الصفحة.": "Previous sales and profit remain in reports. Reactivate products from “Inactive products” at the top of the page.",
  "بعض الأصناف المحددة لا يزال لها رصيد في المخزون — تأكد أنها فعلاً متوقفة ولن تُباع.": "Some selected products still have stock. Verify that they should be deactivated.",
  "المعاينة بالمقاس الفعلي على الورق. في نافذة الطباعة اجعل الهوامش «بلا» والمقياس 100%، وإلا صغّرها المتصفح.": "This preview uses the actual print size. Use no margins and 100% scale in the print dialog.",
  "طباعة الملصق": "Print label",
  "صنفاً نشطاً بلا باركود. سيُولَّد لكلٍّ منها باركود داخلي EAN-13 صالح يبدأ بـ2 — النطاق المحجوز للاستعمال داخل المتجر، فلا يصطدم بباركود مصنع.": "active products need barcodes. Each will receive a valid internal EAN-13 barcode beginning with 2, reserved for internal store use.",
  "الباركود الجديد": "New barcode",
  "تُؤخذ نسخة احتياطية من القاعدة قبل الكتابة، ويُذكر اسمها بعد التنفيذ.": "A backup is taken before saving, and its name is shown when complete.",
  "راجع الأصناف بلا تكلفة": "Review products without costs",
  "رقم فاتورة المورد": "Supplier invoice number",
  "تاريخها": "Invoice date",
  "تأكيد حذف الفاتورة": "Confirm invoice deletion",
  "جاري تحميل الفاتورة...": "Loading invoice...",
  "مسدَّدة": "Paid",
  "مدفوعة جزئياً": "Partially paid",
  "جُردت": "Checked",
  "فحص": "Check",
  "سطر المورد": "Supplier item",
  "تكلفة الوحدة": "Unit cost",
  "لم يتغيّر": "Unchanged",
  "سداد للمورد": "Pay supplier",
  "المتبقي كاملاً": "Full outstanding amount",
  "الفاتورة مسدَّدة بالكامل.": "This invoice is paid in full.",
  "الجرد وبيانات الفاتورة": "Verification & invoice details",
  "حفظ البيانات": "Save details",
  "حذف الفاتورة": "Delete invoice",
  "الكميات والتكاليف لا تُعدَّل بعد الاستلام: البنود حرّكت المخزون والتكاليف وربح ما بِيع منها. التصحيح المحاسبي يكون بفاتورة معاكسة. والحذف لفاتورة ما كان يجب أن توجد أصلاً — نفقةٍ سُجّلت بضاعةً مثلاً — فيعكس أثرها كاملاً ويزيلها من كشف المورد.": "Quantities and costs cannot be edited after receiving because they affect inventory, costs, and profit. Use a reversing invoice for accounting corrections. Delete only an invoice that should never have existed, such as an expense entered as inventory.",
  "سيُعكس أثر الفاتورة كاملاً ثم تُحذف. تُؤخذ نسخة احتياطية قبل الكتابة، ويُقيَّد كل ذلك في سجل التدقيق.": "The invoice’s effects will be reversed before deletion. A backup is taken first and the changes are recorded in the audit log.",
  "ما لا يُعكس تلقائياً": "Effects that will not be reversed automatically",
  "ملف الفاتورة": "Invoice file",
  "تصوير الفاتورة": "Photograph invoice",
  "معاينة فاتورة PDF": "Preview invoice PDF",
  "اختر مورداً أو اكتب اسماً جديداً": "Choose a supplier or enter a new name",
  "الرقم الضريبي للمورد": "Supplier VAT number",
  "أسعار المورد": "Supplier prices",
  "عُلّم عند الفحص والجرد": "Mark when checked",
  "ابحث بالاسم أو الباركود أو رقم الصنف": "Search by name, barcode, or product code",
  "وحدات العبوة": "Units per pack",
  "عدد وحدات البيع داخل العبوة المشتراة — من عمود الوحدة في الفاتورة": "Sale units in each purchased pack, as shown in the invoice’s unit column",
  "حذف السطر": "Remove row",
  "اسم الصنف كما سيُحفظ": "Product name to save",
  "اتركه فارغاً أو ولّده": "Leave blank or generate",
  "خصم المورد (بنفس أساس أسعاره)": "Supplier discount (on the same tax basis as prices)",
  "مدخلات غير محفوظة": "Unsaved changes",
  "صنف جديد": "New product",
  "بلا صنف": "No product",
  "ذاكرة المورد": "Supplier matches",
  "جارٍ فتح مسودة الفاتورة...": "Opening invoice draft...",
  "احفظ المدخلات كمسودة لاستكمالها لاحقاً؛ الاعتماد هو الذي يسجّل الشراء ويستلم المخزون.": "Save a draft to continue later. Approving the invoice records the purchase and receives the inventory.",
  "رفع صورة أو PDF": "Upload image or PDF",
  "أضف سطراً يدوياً": "Add row manually",
  "قارئ اشتراك ChatGPT يحتاج تسجيل دخول. الإدخال اليدوي متاح، ولا يُستخدم رصيد API.": "Sign in to use the ChatGPT subscription reader. Manual entry remains available; no API credit is used.",
  "قراءة باشتراك ChatGPT، بدون رصيد API. صور وPDF حتى 10 ميغابايت و6 صفحات. قد تستغرق القراءة بضع دقائق؛ راجع المسودة قبل الاعتماد.": "Read with your ChatGPT subscription without API credit. Images and PDFs up to 10 MB and 6 pages are supported. Reading may take a few minutes; review the draft before approval.",
  "عرض النص المقروء للمراجعة": "Show extracted text for review",
  "اعتماده يضيف مخزوناً لم تستلمه.": "Approving adds inventory that has not been received.",
  "شاملة الضريبة": "Tax inclusive",
  "سطر الفاتورة": "Invoice item",
  "الصنف في متجرك": "Product in your catalog",
  "بالعبوة": "Per pack",
  "ارفع إلى": "Raise to",
  "لا توجد أسطر بعد": "No items yet",
  "صوّر فاتورة المورد لتُقرأ تلقائياً، أو أضف الأسطر يدوياً.": "Photograph the supplier invoice to read it automatically, or add rows manually.",
  "مجاميع المورد المطبوعة — راجعها قبل الاعتماد": "Printed supplier totals — review before approval",
  "الخصم يوزع على تكلفة الأصناف؛ لا يعتمد مبلغ مطبوع يخالف الأسطر. ما لم تقرأه الفاتورة يترك فارغاً.": "Discount is allocated across item costs. Printed totals must match the rows. Unread values remain blank.",
  "إجمالي الفاتورة (شامل الضريبة)": "Invoice total (tax inclusive)",
  "الباقي على المتجر": "Amount still owed by the shop",
  "أسعار سترتفع": "Prices to increase",
  "طبّق قاعدة التسعير": "Apply pricing rule",
  "سُدّدت كاملة": "Paid in full",
  "احفظ مدخلات الفاتورة كمسودة لتراجعها وتستكملها لاحقاً.": "Save the invoice as a draft for review and completion later.",
  "مغادرة بدون حفظ": "Leave without saving",
  "إنشاء طلب شراء": "Create purchase order",
  "لم تُضف أصنافاً بعد": "No products added yet",
  "أضف المنتجات والكميات والتكلفة لتكوين الطلب.": "Add products, quantities, and costs to create the order.",
  "استيراد فاتورة مورد": "Import supplier invoice",
  "طلب شراء يدوي": "Manual purchase order",
  "مدخلات محفوظة للمراجعة والاستكمال قبل اعتماد الشراء.": "Saved entries to review and complete before approving the purchase.",
  "الأسطر": "Rows",
  "آخر حفظ": "Last saved",
  "المتابعة": "Continue",
  "استكمال ومراجعة": "Continue review",
  "أصناف الطلب": "Order items",
  "إضافة صنف": "Add product",
  "لا حركات سداد": "No payments",
  "لم تُسجَّل أي دفعة لهذا المورد بعد.": "No payments have been recorded for this supplier.",
  "لا فواتير": "No invoices",
  "لم تُسجَّل فواتير شراء لهذا المورد.": "No purchase invoices have been recorded for this supplier.",
  "جاري تحميل كشف الحساب...": "Loading account statement...",
  "المسدَّد على الفواتير": "Payments against invoices",
  "سداد على الحساب": "Payment on account",
  "الرصيد كاملاً": "Full account balance",
  "هذه دفعة على الحساب لا تُنسب إلى فاتورة. لسداد فاتورة بعينها افتحها من الجدول.": "This payment is applied to the account. Open an invoice from the table to pay that specific invoice.",
  "حركات السداد": "Payment activity",
  "فاتورة المورد": "Supplier invoice",
  "بحث ذكي في الموردين...": "Search suppliers...",
  "جاري تحميل المستحقات...": "Loading amounts due...",
  "مورد جديد": "New supplier",
  "البريد": "Email",
  "قبل النقل إلى النموذج": "Before entering figures in the return",
  "تفصيل شهري": "Monthly breakdown",
  "وعاء المخرجات": "Output taxable base",
  "وعاء المدخلات": "Input taxable base",
  "الإقرار يُقدَّم عن شهر أو ربع بحسب تسجيل المنشأة — التفصيل يجعل نقل الأرقام مطابقةً لا جمعاً.": "Returns are monthly or quarterly according to the business registration. Use the breakdown to transfer the figures accurately.",
  "· الفترة من": "· Period from",
  "− ضريبة المدخلات": "− Input VAT",
  "ضريبة القيمة المضافة": "VAT",
  "ضريبة القيمة المضافة (15%)": "VAT (15%)",
  "ضريبة القيمة المضافة (5%)": "VAT (5%)",
  "في هذا النموذج تغييرات لم تُحفظ — مغادرته الآن تُلغيها.": "This form has unsaved changes. Leaving will discard them.",
  "المستعملة في المحل": "Used in the shop",
  "تصنيفات مقترحة": "Suggested categories",
  "تظهر للكاشير عند اختيار العميل في الفاتورة.": "Shown to the cashier when this customer is selected.",
  "الاسم / اسم المنشأة": "Name / business name",
  "15 رقماً يبدأ بـ 3": "15 digits starting with 3",
  "أدخل بيانات الصنف ثم احفظ": "Enter product details, then save",
  "أي تعديل هنا ينعكس فوراً في شاشة الكاشير.": "Changes appear in POS immediately.",
  "الوحدة / العبوة": "Unit / pack",
  "عند التفعيل: يُباع الصنف بأي كمية ولا يُمنع البيع ولا تظهر له تنبيهات إعادة الطلب.": "When enabled, any quantity can be sold without stock limits or reorder alerts.",
  "التكلفة لكل ريال مبيعات": "Cost per SAR of sales",
  "اتركه فارغاً أو ولّد باركوداً": "Leave blank or generate a barcode",
  "اختر تصنيفاً أو اكتب جديداً": "Choose a category or enter a new one",
  "اختر نوع العبوة أو اكتبها": "Choose or enter a unit / pack",
  "الاسم، الجوال، الرقم الضريبي، السجل أو العنوان...": "Name, mobile, tax number, registration, or address...",
  "ابحث بالاسم أو SKU أو الباركود...": "Search by name, SKU, or barcode...",
  "ضريبة القيمة المضافة (": "VAT (",
  "٪": "%",
  "كمية مفتوحة — يُباع بأي كمية ولا يُتتبَّع مخزونه": "Unlimited quantity — inventory is not tracked",
  "مبلغ مفتوح — الكاشير يكتب المبلغ بالريال بدل الكمية": "Open amount — the cashier enters an amount in SAR",
  "الصنف مفتوح المبلغ: سعره ريال واحد والكمية هي المبلغ.": "Open-amount product: the price is SAR 1 and the quantity represents the amount.",
  "ربح الوحدة": "Unit profit",
  "حفظ ثم المنتج التالي": "Save and open next product",
  "إغلاق": "Close",
  "صفحة المنتج والحركة": "Product details & activity",
  "حذف من القوائم": "Remove from catalog",
  "لا توجد تكلفة — هذا الصنف يُستبعد من حساب الربح": "No cost recorded — excluded from profit calculation",
  "التكلفة تساوي سعر البيع أو تفوقه — كل قطعة تُباع بخسارة": "Cost meets or exceeds the selling price — each unit is sold at a loss",
  "توليد رمز جديد يتبع ترقيم الكتالوج": "Generate a new catalog code",
  "توليد باركود داخلي EAN-13 صالح": "Generate a valid internal EAN-13 barcode",
  "يحفظ هذا المنتج ويفتح الذي يليه في القائمة مباشرة": "Save this product and open the next one",
  "إضافة مورد": "Add supplier",
  "اسم المسؤول": "Contact name",
  "اسم الشركة": "Company name",
  "الرصيد الافتتاحي": "Opening balance",
  "حفظ المورد": "Save supplier",
  "اكتب أي تصنيف جديد وسيُحفظ ويظهر في القائمة لاحقاً": "Enter a new category to save it for future use",
  "ضريبة الإيصال (ر.س)": "Receipt VAT (SAR)",
  "احسب": "Calculate",
  "اتركها صفراً إن كان الإيصال بلا ضريبة (رواتب، رسوم حكومية، مورّد غير مسجَّل)": "Leave at zero for receipts without VAT, such as salaries, government fees, or unregistered suppliers",
  "بنود الإيصال — اختيارية": "Receipt items — optional",
  "مثال: كماليات ونثريات": "Example: supplies and incidentals",
  "وصف مختصر — مثال: أكياس ورقية مقاس وسط": "Short description — e.g. medium paper bags",
  "الخصم (ر.س)": "Discount (SAR)",
  "أضف منتجات العرض": "Add quotation products",
  "عميل عام": "Walk-in customer",
  "منتج نشط": "active products",
  "إجمالي المستحق لنا (": "Total receivable (",
  "مدين)": "debtors)",
  "قيد في هذه الفترة": "entries in this period",
  "حدّد الظاهر (": "Select visible (",
  "آخر": "Latest",
  "ضريبة المدخلات": "Input VAT",
  "الفترة من": "Period from",
  "الرقم الضريبي:": "VAT number:",
  "مورداً · مجموع أرصدة الحسابات": "suppliers · Total account balances",
  "توزيع المتبقي على الفواتير حسب عمرها — مجموعه": "Outstanding invoices by age — total",
  "رصيد الحساب يزيد على المتبقي من الفواتير بـ": "Account balances exceed outstanding invoices by",
  "— أرصدة افتتاحية لموردين بلا فواتير مسجَّلة.": "— opening balances for suppliers with no recorded invoices.",
  "رقم السجل التجاري": "Commercial registration number",
  "العنوان المختصر — لطلبات سلة": "Short address — for Salla orders",
  "العنوان القديم — محفوظ للمراجعة": "Previous address — kept for reference",
  "15 رقماً عند توفره": "15 digits, if available",
  "رقم السجل للمنشآت": "Business registration number",
  "مثال: المدينة المنورة": "Example: Madinah",
  "أربعة أرقام": "Four digits",
  "خمسة أرقام": "Five digits",
  "أربعة حروف ثم أربعة أرقام": "Four letters followed by four digits",
  "حالة الطلب": "Order status",
  "مستلمة": "Received",
  "قيد الطلب": "Ordered",
  "آجل": "On account",
  "تسوية جرد": "Stock adjustment",
  "تالف": "Damaged",
  "رصيد افتتاحي": "Opening balance",
  "٪ من المبيعات": "% of sales",
  "٪ فوق ما بِعت": "% above sales",
  "الملخص": "Summary",
  "تقرير المبيعات — بيت الحناء والعطارة": "Sales report — Bait Henna & Herbs",
  "القيمة": "Value",
  "صافي المبيعات (ر.س)": "Net sales (SAR)",
  "متوسط الفاتورة (ر.س)": "Average invoice (SAR)",
  "الضريبة المحصلة (ر.س)": "Tax collected (SAR)",
  "الربح التقديري (ر.س)": "Estimated profit (SAR)",
  "هامش الربح (%)": "Profit margin (%)",
  "المرتجعات (ر.س)": "Returns (SAR)",
  "المبيعات (ر.س)": "Sales (SAR)",
  "المبلغ (ر.س)": "Amount (SAR)",
  "الصافي (ر.س)": "Net (SAR)",
  "فواتير البيع": "Sales invoices",
  "العمليات": "Transactions",
  "المبيعات المرحّلة": "Imported sales",
  "مدفوعة": "Paid",
  "عميل مباشر": "Walk-in customer",
  "مدير النظام": "Administrator",
  "موظف مبيعات": "Sales associate",
  "الأفراد والمنشآت والبيانات الضريبية والأرصدة الآجلة": "Individuals, businesses, tax details, and account balances",
  "ملف عملاء موحّد": "Shared customer records",
  "أي إضافة أو تعديل هنا يظهر فوراً في لوحة التحكم ونظام الكاشير وعروض الأسعار.": "Changes here appear immediately in management, POS, and quotations.",
  "الجوال والتواصل": "Mobile & contact details",
  "إجراء": "Action",
  "إجراءات": "Actions",
  "ملخصات مجمّعة للاطلاع التاريخي — لا تدخل الفواتير ولا المخزون ولا حساب الربح ولا الإقرار الضريبي": "Historical summaries — excluded from invoices, inventory, profit, and VAT returns",
  "هذه الأرقام ملخصات مجمّعة من النظام السابق، وليست فواتير. لا يوجد فيها تاريخ لكل عملية ولا أصنافها، فلا يمكن — ولا يصح — تحويلها إلى فواتير. تُعرض هنا وفي التقارير كرقم مستقل بجانب مبيعات النظام، لا مخلوطاً بها.": "These are summaries from the previous system, with no individual transaction dates or products. They cannot be converted to invoices. Reports show them separately from this system’s sales.",
  "اضغط على أي منتج ليُفتح محرّره تحته مباشرة — بلا مغادرة القائمة": "Select a product to edit it directly in the list",
  "ملف منتجات موحّد": "Shared product catalog",
  "أي منتج أو سعر أو باركود يتم تعديله هنا يظهر فوراً في لوحة التحكم ونقطة البيع والمخزون.": "Product, price, and barcode changes appear immediately in management, POS, and inventory.",
  "الرمز والباركود": "Code & barcode",
  "المخزون": "Stock",
  "تعديل هنا": "Edit here",
  "منخفض": "Low stock",
  "أوامر الشراء والتوريد وتحديث رصيد المخزون": "Purchase orders, receiving, and inventory updates",
  "إجمالي الطلبات": "Total orders",
  "طلبات مستلمة": "Received orders",
  "قيمة المشتريات": "Purchase value",
  "رقم الطلب": "Order number",
  "المسدَّد": "Paid",
  "المتبقي": "Remaining",
  "مصروفات المحل والمتجر: تغليف وتنظيف وقرطاسية وإيجار وغيرها — منفصلة عن مشتريات البضاعة": "Shop and online store expenses: packaging, cleaning, stationery, rent, and more — separate from inventory purchases",
  "النفقة تكلفة فترة: تُطرح من ربح الشهر الذي صُرفت فيه. وهي غير مشتريات البضاعة — تلك مخزون لا يصير تكلفة إلا يوم بيعه.": "Expenses reduce profit in the month incurred. Inventory purchases become a cost when the goods are sold.",
  "بيت الحناء والعطارة — تقرير النفقات": "Bait Henna & Herbs — Expense report",
  "نفقة مسجّلة": "recorded expenses",
  "النفقات حسب التصنيف": "Expenses by category",
  "سجّل أول نفقة لتظهر هنا موزّعة على تصنيفاتها.": "Record an expense to see the category breakdown.",
  "النفقات حسب الشهر": "Monthly expenses",
  "الشهر": "Month",
  "ستظهر الأشهر هنا بعد تسجيل النفقات.": "Monthly totals will appear after expenses are recorded.",
  "الرقم": "Number",
  "الضريبة": "Tax",
  "سجّلها": "Recorded by",
  "لا توجد نفقات في هذه الفترة": "No expenses in this period",
  "غيّر النطاق أو سجّل نفقة جديدة.": "Change the period or record an expense.",
  "دليل الموردين والأرصدة وبيانات التواصل": "Supplier directory, balances, and contact details",
  "خلال ٣٠ يوماً": "Within 30 days",
  "٣١ – ٦٠ يوماً": "31–60 days",
  "أكثر من ٦٠ يوماً": "Over 60 days",
  "فواتير غير مسدَّدة": "Unpaid invoices",
  "أقدم فاتورة": "Oldest invoice",
  "خلال ٣٠": "Within 30",
  "٣١–٦٠": "31–60",
  "+٦٠": "60+",
  "متبقٍّ على الفواتير": "Outstanding invoices",
  "رصيد الحساب": "Account balance",
  "الموردون النشطون": "Active suppliers",
  "الرصيد المستحق": "Amount due",
  "عروض العملاء وفواتير طلبات المتجر": "Customer quotations and online store invoices",
  "قبل الضريبة": "Before tax",
  "القاعدة نفسها التي تعمل عند اعتماد الفاتورة — مطبَّقة على ما هو مسجَّل أصلاً": "The invoice pricing rule, applied to the current catalog",
  "لا شيء محدَّد مسبقاً هنا": "No products are selected automatically",
  "تكلفة تفوق السعر بأضعاف نادراً ما تعني بيعاً بخسارة — الأغلب أن الرقمين ليسا على وحدة واحدة: تكلفة عبوة كاملة مسجَّلة أمام سعر حبة. عمود «تعادل» يقدّر كم وحدة تحويها عبوتك ليصير سعرك الحالي منطقياً؛ فإن جاء قريباً من عدد حبّات الكرتون فالخلل في وحدة التكلفة لا في السعر، وعلاجه قسمة التكلفة على حجم العبوة لا رفع السعر. لا ترفع سعراً هنا قبل أن تتأكد أن التكلفة والسعر على الوحدة نفسها.": "A cost several times higher than the selling price often means a pack cost was entered against a unit price. “Equivalent units” estimates the pack size. Check the units and divide the cost by the pack size where appropriate before approving a price increase.",
  "الهامش": "Margin",
  "تعادل": "Equivalent units",
  "لا أصناف في هذه الشريحة": "No products in this group",
  "لا شيء يحتاج مراجعة هنا.": "Nothing needs review here.",
  "أين ذهب كل ريال بِعته — ومعه حركة الصندوق": "Where sales revenue goes, alongside cash flow",
  "بيت الحناء والعطارة — الربح والخسارة": "Bait Henna & Herbs — Profit & loss",
  "بِعتها في هذه الفترة": "sold in this period",
  "من المبيعات": "of sales",
  "فوق ما بِعت": "above sales",
  "تخرج من الطرفين: لا إيرادها يُحتسب ولا تكلفتها": "Excluded from both revenue and cost",
  "محصّلة للدولة، ليست إيرادك": "Collected for the tax authority; excluded from revenue",
  "تكلفة البضاعة المباعة": "Cost of goods sold",
  "تكلفة ما بِيع فعلاً، مثبّتة يوم بيعه": "Cost of goods actually sold, recorded at the time of sale",
  "صنف بلا تكلفة مسجّلة خرجت من الحساب — ربحها لا يظهر لك. سجّل تكلفتها ليدخل هنا.": "products without recorded cost are excluded. Record their costs to include their profit.",
  "كاش وبطاقة — الآجل ليس قبضاً": "Cash and card receipts — excludes sales on account",
  "مبيعات سابقة وصل مالها الآن": "Payments received for previous sales",
  "النفقات": "Expenses",
  "داخل الصندوق": "Cash inflow",
  "خارج الصندوق": "Cash outflow",
  "لا يُقارن بالربح: بيعٌ بالآجل يرفع الربح ولا يدخل الصندوق، وسدادُ مورد يُنقص الصندوق ولا يمسّ ربح الشهر.": "Cash flow differs from profit: sales on account affect profit before payment, while supplier payments reduce cash without changing the month’s profit.",
  "فاتورة في الفترة": "invoices in this period",
  "لا تُطرح من ربح الشهر: المشتراة مخزون لا يصير تكلفة إلا يوم بيعه، وتكلفته يومها هي «تكلفة البضاعة المباعة» في الكشف. طرحُها من مبيعات الشهر يُظهر شهر الشحنة خاسراً وشهر بيعها رابحاً بلا وجه حق.": "Purchases are inventory until sold. Their recorded cost is then included in cost of goods sold. Subtracting all purchases immediately would distort monthly profit.",
  "ضريبة المخرجات ناقص ضريبة المدخلات — تحضيراً لنموذج الهيئة": "Output VAT less input VAT, prepared for the tax return",
  "هذا الربع": "This quarter",
  "الربع الماضي": "Last quarter",
  "بيت الحناء والعطارة — الإقرار الضريبي": "Bait Henna & Herbs — VAT return",
  "كشف تحضيري للمراجعة مع محاسبك — ليس إقراراً مقدَّماً ولا استشارة ضريبية. راجِع التنبيهات أدناه قبل نقل أي رقم إلى نموذج الهيئة.": "A preparation statement for review with your accountant. This is not a submitted return or tax advice. Review the notes below before transferring figures to the tax return.",
  "صافي الضريبة المستحقة للهيئة": "Net VAT payable",
  "ضريبة المخرجات": "Output VAT",
  "خانات الإقرار": "Return entries",
  "البند": "Item",
  "فاتورتان": "2 invoices",
  "بلا فواتير": "No invoices",
  "إشعارات دائنة (مرتجعات)": "Credit notes (returns)",
  "بلا إشعارات دائنة — تُطرح من المخرجات": "No credit notes — deducted from output VAT",
  "فواتير طلبات المتجر المحتسبة هنا": "Online store invoices included here",
  "صافي ضريبة المخرجات": "Net output VAT",
  "بلا فواتير موردين": "No supplier invoices",
  "النفقات الخاضعة للضريبة": "Taxable expenses",
  "بلا نفقات": "No expenses",
  "صافي ضريبة المدخلات": "Net input VAT",
  "صافي الضريبة المستحقة": "Net VAT payable",
  "تاريخ استحقاق فاتورة الشراء هو تاريخ فاتورة المورد المطبوع لا تاريخ إدخالها في النظام — فاتورة سبتمبر تُدخَل في أكتوبر تخصّ إقرار سبتمبر.": "Purchase invoices use the printed supplier invoice date. An invoice dated September and entered in October belongs to September’s return.",
  "تحليل المبيعات وطرق الدفع وأداء المنتجات": "Sales analysis, payment methods, and product performance",
  "بيت الحناء والعطارة — تقرير المبيعات": "Bait Henna & Herbs — Sales report",
  "صافي المبيعات = المبيعات − المرتجعات · متوسط الفاتورة يُحسب من فواتير البيع وحدها ولا يقسم عليه المرتجع · الأرقام كلها من فواتير هذا النظام فقط": "Net sales = sales − returns. Average invoice value uses sales invoices only. These figures include invoices from this system only.",
  "صافي الفترة": "Net for this period",
  "لكل فاتورة": "Per invoice",
  "ضمن الإجمالي": "Included in total",
  "لا توجد مدفوعات في هذه الفترة.": "No payments in this period.",
  "لا توجد مبيعات أصناف": "No product sales",
  "لم تُسجَّل مبيعات أصناف في هذه الفترة.": "No product sales were recorded in this period.",
  "جاري تجهيز التقرير...": "Preparing report...",
  "تعذر تحميل التقرير": "Unable to load report",
  "تعذر إنشاء التقرير": "Unable to create report",
  "اعتماد حسابات البائعين ومتابعة ارتباطهم بالمبيعات": "Approve sales accounts and review their sales activity",
  "حسابك الحالي": "Your current account",
  "من فعل ماذا ومتى — كل عملية حسّاسة أو محاولة مرفوضة": "Who did what and when — sensitive actions and rejected attempts",
  "السجل للقراءة فقط ولا يمكن تعديله أو حذفه من الواجهة.": "This log is read-only and cannot be edited or deleted from the interface.",
  "الوقت": "Time",
  "المستخدم": "User",
  "الدور": "Role",
  "العملية": "Action",
  "الجهة": "Entity",
  "التفاصيل": "Details",
  "لا توجد عمليات مسجلة بعد": "No activity recorded yet",
  "مبيعات مرحّلة من نظام سابق — فترات متقاطعة مع نطاق التقرير": "Imported sales — periods overlapping the report range",
  "ملخصات مجمّعة، ليست فواتير، ولا تدخل الأرقام أعلاه": "Summaries only, excluded from the figures above",
  "كل فترة ملخص واحد لا يقبل التجزئة على الأيام، فتُعرض بكامل قيمتها متى تقاطعت مع النطاق ولو جزئياً — لا بجزئها الواقع داخله.": "Each imported period is an indivisible summary. Its full value is shown when it overlaps the report range.",
  "إجمالي الفترات المتقاطعة مع هذا النطاق": "Total for overlapping periods",
  "فترات مرحّلة أخرى خارج النطاق": "Other imported periods outside this range",
  "إجمالي كل المرحّل في النظام": "Total imported sales"
};
